export enum MenuContentTestIds {
  ROOT = 'menu-content-root',
  HEADING = 'menu-content-heading',
  TEXT = 'menu-content-text',
  AVATAR = 'menu-content-avatar',
  USER_EMAIL = 'menu-content-user-email',
  USER_PHONE = 'menu-content-user-phone',
  USER_NAME = 'menu-content-user-name',
  BENEFITS_LINK = 'menu-content-benefits-link',
}
